import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en/en-translations.json";
import fr from "./locales/fr/fr-translations.json";
i18n.use(initReactI18next).init({
  fallbackLng: "fr",
  lng: "fr",
  resources: {
    en: {
      translations: en,
    },
    fr: {
      translations: fr,
    },
  },
  ns: ["translations"],
  defaultNS: "translations",
  interpolation: {
    escapeValue: false,
  },
});

i18n.languages = ["en", "fr"];

if (typeof document !== "undefined") {
  document.documentElement.lang = i18n.language || "fr";
}

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
});

export default i18n;
